import { lazy } from "react";

// project imports
import Loadable from "ui-component/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import MainLayout from "layout/MainLayout";

// Master routing
const ProgramList = Loadable(
  lazy(() => import("views/mastersetup/progaram/Main"))
);
const Industries = Loadable(lazy(() => import("views/mastersetup/industries")));
const VideoCategory = Loadable(lazy(() => import("views/mastersetup/video-category")));
const FunctionalAreas = Loadable(
  lazy(() => import("views/mastersetup/functional-area"))
);
const BatchList = Loadable(lazy(() => import("views/mastersetup/batch/Main")));
const BranchList = Loadable(
  lazy(() => import("views/mastersetup/branch/Main"))
);
const UserList = Loadable(lazy(() => import("views/createUser/index")));
const EventType = Loadable(
  lazy(() => import("views/mastersetup/eventType/index"))
);
const ReactFormTableSetup = Loadable(
  lazy(() => import("views/mastersetup/tableformSetup/index"))
);


// ==============================|| AUTH ROUTING ||============================== //

const MasterRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "/program/list",
      element: <ProgramList />,
    },
    {
      path: "/table/form",
      element: <ReactFormTableSetup />,
    },
    {
      path: "/industries/list",
      element: <Industries />,
    },
    {
      path: "/functional-area/list",
      element: <FunctionalAreas />,
    },
    {
      path: "/video-category/list",
      element: <VideoCategory />,
    },
    {
      path: "/batch/list",
      element: <BatchList />,
    },
    {
      path: "/branch/list",
      element: <BranchList />,
    },
    {
      path: "/user/list",
      element: <UserList />,
    },
    {
      path: "/eventType/list",
      element: <EventType />,
    },
  ],
};

export default MasterRoutes;
